export default __webpack_public_path__ + "static/media/background_0.e378fd88.mp4";